<template>
    <div id="home">
        <swiper :options="swiperOption">
            <swiper-slide>
                <img src="../assets/img/home_banner_1.jpg">
            </swiper-slide>
            <swiper-slide>
                <img src="../assets/img/home_banner_2.jpg">
            </swiper-slide>
            <swiper-slide>
                <img src="../assets/img/home_banner_3.jpg">
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="posters clearfix">
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div class="app-preview">
            <img src="../assets/img/home_app.png" alt="">
        </div>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            swiperOption: {
                autoplay:true,
                loop:true,
                speed:1500,
                pagination: {
                    el: '.swiper-pagination'
                }
            }
        }
    }
}
</script>

<style>
    .swiper-container {
        margin-bottom:15px;
    }
    .swiper-container .swiper-slide img {
        width:100%;
        display:block;
    }
</style>